import styled from "styled-components"
import { Link } from "gatsby"

import { minWidth } from "utils"
import Icon from "icons"

export const Container = styled.footer`
  color: ${({ theme }) => theme.colors.text.alternate};
  background-color: #2260b2;
  position: relative;
  display: flex;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  flex-direction: column;

  padding: 2rem 0;
  ${minWidth.mobile`
    padding: 3rem 0;  
  `}

  ${minWidth.tablet`
    padding: 4rem 0;
  `}
`

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 1rem 3rem;
  gap: 2rem;

  ${minWidth.mobile`
    padding: 2rem 4rem 1rem 4rem;  
  `}

  ${minWidth.tablet`
    flex-direction: row;
    padding: 3rem 8.5rem 1.5rem 8.5rem;
    gap: 1.5rem;
  `}
`

export const GroupedSections = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0;

  ${minWidth.tablet`
    flex-direction: row;
    gap: 2rem;
  `}

  ${minWidth.desktop`
    gap: 4rem;
  `}
`

export const GroupedSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 0.05rem solid #fff;

  &:first-child {
    border-top: 0.05rem solid #fff;
  }

  ${minWidth.tablet`
    border-bottom: none;
    max-width: 15rem;

    &:first-child {
      border-top: none;
    }
  `}
`

export const GroupedSectionTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 500;
  padding: 1.2rem 0;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  margin-bottom: 0;
  line-height: 1.612rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${minWidth.tablet`
    font-size: 2rem;
    line-height: 1.35rem;
    cursor: default;
    margin-bottom: 3rem;
    padding: 0;
  `}
`

export const ExpandIcon = styled.span`
  font-size: 2.4rem;
  font-weight: 300;
  transform: ${({ isExpanded }) => (isExpanded ? "rotate(45deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;

  ${minWidth.tablet`
    display: none;
  `}
`

export const GroupedSectionItems = styled.div`
  display: ${({ isExpanded }) => (isExpanded ? "flex" : "none")};
  flex-direction: column;
  padding-bottom: 1rem;
  margin: 1rem 0;

  ${minWidth.tablet`
    display: flex;
    padding-bottom: 0;
  `}
`

export const GroupedSectionLink = styled(Link)`
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.5rem;
  margin-bottom: 1.4rem;

  &:hover {
    opacity: 0.7;
  }
`

export const GroupedSectionExternalLink = styled.a`
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.5rem;
  margin-bottom: 1.4rem;

  &:hover {
    opacity: 0.7;
  }
`

export const IconSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;

  ${minWidth.tablet`
    margin-top: 0;
  `}
`

export const Icons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;

  ${minWidth.tablet`
    gap: 0.8rem; 
  `}

  ${minWidth.desktop`
    gap: 2rem;
  `}
`

export const SocialIcon = styled(Icon)`
  max-width: 3rem;
  color: ${({ theme }) => theme.colors.text.alternate};
`

export const Copyright = styled.div`
  font-size: 1rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.alternate};
`

export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  padding: 1rem 2rem;
  align-items: flex-start;

  ${minWidth.mobile`
    padding: 2rem 4rem 0 4rem;
  `}

  ${minWidth.tablet`
    flex-direction: row;
    gap: 2rem;
    padding: 3rem 8.5rem 0 4rem;
  `}
`

export const MBGLogoContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
  margin: auto;
  order: 2;

  ${minWidth.tablet`
    flex: 1 0 70%;
    order: 1;
    width: auto;
    margin: auto;
    margin-top: -1.5rem;
    max-width: 100%;
  `}

  ${minWidth.desktop`
    max-width: 67%;
    margin-top: -2rem;
  `}

  ${minWidth.hamburgerLarge`
    margin-top: -2.5rem;
  `}

  ${minWidth.desktopL`
    margin-top: -3rem;
  `}

  ${minWidth.desktopXL`
    margin-top: -3.5rem;
  `}

  ${minWidth.desktopXXL`
    margin-top: -4rem;
  `}
`

export const MBGLogoFull = styled(Icon)`
  display: none;
  opacity: 0.3;

  ${minWidth.tablet`
    display: block;
    width: 100%;
    height: 100%;
  `}
`

export const MBGLogoShort = styled(Icon)`
  display: block;
  width: 7.5rem;
  height: 7.5rem;

  ${minWidth.tablet`
    display: none;
  `}
`

export const BottomRowContent = styled.div`
  display: flex;
  flex-direction: column;
  order: 1;

  ${minWidth.tablet`
    flex: 1 0 33%;
    order: 2;
  `}
`

export const Disclaimer = styled.p`
  display: ${({ isHomePage }) => (isHomePage ? "flex" : "none")};
  max-width: ${({ isHomePage }) => (isHomePage ? "100%" : "56.7rem")};
  padding: 1rem 2rem;
  border: 0.1rem solid #fff;
  font-size: 1rem;
  line-height: 1.1rem;
  color: ${({ theme }) => theme.colors.text.alternate};
`

export const ButtonLink = styled.button`
  margin: 0.5rem 0.4rem;
  font-size: 1rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.alternate};
  background: none;
  box-shadow: none;

  &:hover {
    opacity: 0.7;
  }
`

export const UtilityLinks = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  a, button {
    margin: 0.5rem 0.5rem;
    font-size: 1rem;
    line-height: 1.6rem;
    color: ${({ theme }) => theme.colors.text.alternate};

    &:hover {
      opacity: 0.7;
    }
  }
`

export const CookieSettingsButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`
